// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__ERobW","move-in":"Modal_move-in__bPFOm","backdrop-fade-in":"Modal_backdrop-fade-in__PZvtF"};